import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CountryCode } from 'src/app/interfaces';
import { environment } from 'src/environments/environment';
import { PhoneEvent } from 'src/app/interfaces';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.css']
})
export class PhoneInputComponent implements OnInit, OnChanges {

  constructor(
    private _snackBar: MatSnackBar
  ) { }

  countryCodes: CountryCode[] = environment.countryCodes;
  selectedCountryCode: CountryCode = environment.countryCodes[0];
  @Input() error?: boolean;
  @Input() hint?: string;
  @Input() disabled: boolean = false;
  @Input() initialPhoneNumber?: string;
  @Input() initialDialCode?: string;
  @Output() errorChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onPhoneNumberCompleted: EventEmitter<PhoneEvent> = new EventEmitter<PhoneEvent>();

  hasError: ValidatorFn = (control: FormControl) => {
    return (this.error) ? { 'hasError': true } : null;
  }

  phoneControl: FormControl = new FormControl({value: null, disabled: this.disabled}, [Validators.required, Validators.min(100000000), Validators.max(999999999), this.hasError])

  ngOnInit(): void {
    if (this.initialPhoneNumber) {
      this.phoneControl.setValue(this.initialPhoneNumber);
    }
    if (this.initialDialCode) {
      const match = this.countryCodes.find(c => c.dial_code === this.initialDialCode);
      if (match) this.selectedCountryCode = match;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.error && changes.error.currentValue) {
      this.phoneControl.markAsTouched();
      this.phoneControl.setErrors({hasError: true});
    }
    if (changes.disabled) {
      if (changes.disabled.currentValue) {
        this.phoneControl.disable();
      } else {
        this.phoneControl.enable();
      }
    }
  }

  onPhoneNumberTouched() {
    this.errorChange.emit(false);
  }

  sendPhoneNumber() {
    let completePhoneNumber = `${this.selectedCountryCode.dial_code}${this.phoneControl.value}`
    if (this.selectedCountryCode.dial_code == environment.countryCodes[0].dial_code && this.phoneControl.value?.toString().length !== 9) {
      this.openSnackBar(`El número de teléfono debe tener 9 dígitos. El número que ingresaste tiene ${this.phoneControl.value?.toString().length || 0} dígitos.`)
      return;
    }
    this.onPhoneNumberCompleted.emit({
      phoneNumber: this.phoneControl.value,
      dialCode: this.selectedCountryCode.dial_code,
      completePhoneNumber
    });
  }

  openSnackBar(message: string) {
    let action = "Cerrar"
    this._snackBar.open(message, action, {
      duration: 10000,
    });
  }

  onPhoneNumberChange(number: number) {
    if (number && number.toString().length > 13) {
      this.phoneControl.setValue(Number(number.toString().slice(0, 13)));
    }
  }

    getFirstErrorMessage(): string | null {
    const control = this.phoneControl;
    if (!control || !control.errors || !control.touched) return null;
    const priorities = ['hasError', 'required', 'min', 'max', 'pattern'];
    for (const errorType of priorities) {
      if (control.errors[errorType]) {
        if (errorType === 'hasError') return 'components.login_phone.error.used';
        if (errorType === 'required') return 'common.forms.required';
        if (errorType === 'min') return 'components.login_phone.error.minlength';
        if (errorType === 'max') return 'components.login_phone.error.maxlength';
        if (errorType === 'pattern') return 'components.login_phone.error.pattern';
      }
    }
    return null;
  }
}
